import { ColumnDetails } from '../../../../../../../../grid/types/common';
import { css, html } from 'lit';
import { getLabelForEnumValue } from '../../../../../../../../grid/utils/columns';
import { PatchesColumnIndexes, PatchesColumnKeys } from '../types';

export function categoryRenderer(rowData, columnDetails: ColumnDetails<PatchesColumnIndexes, PatchesColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];
  const label = getLabelForEnumValue(columnDetails, cellValue);

  return html` <span class="cell-label">${label}</span> `;
}

export function numericRenderer(rowData, columnDetails: ColumnDetails<PatchesColumnIndexes, PatchesColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];

  return html` <style>
      .numeric-cell {
        font-family: var(--font-family-secondary-mono);
      }
    </style>
    <span class="cell-label numeric-cell">${cellValue}</span>`;
}
